import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import {
  appointmentSelector,
  appointmentReservationSelector,
  queueAppointmentsSelector,
} from '../selector';
import { PlaceHolderIds } from '../../components/PagePlaceholder';
import { shouldShowPlaceholder } from '../../utils/Functions';

export const selectShowAppointmentPagePlaceholder = createSelector(
  [
    appointmentSelector,
    appointmentReservationSelector,
    queueAppointmentsSelector,
  ],
  (appointments, reservations, queueAppointments) => {
    if (appointments.isFetching || reservations.clinics.isFetching)
      return PlaceHolderIds.LOADER;

    let show =
      !appointments.isFetching &&
      !appointments.error &&
      isEmpty(appointments.data) &&
      !queueAppointments.isFetching &&
      isEmpty(queueAppointments.data) &&
      !reservations.clinics.isFetching &&
      isEmpty(reservations.clinics.data) &&
      reservations.clinics.error == null;

    return shouldShowPlaceholder(show, PlaceHolderIds.APPOINTMENTS);
  }
);
